import {observable} from 'mobx';
import {createInstance} from 'utils';
import {LanguageLocaleKey} from './language-locale-key';
import {LanguageLocaleContent} from './language-locale-content';

export class LanguageLocale extends LanguageLocaleKey {
    @observable id!: number;

    @observable initialContent: string = '';

    @observable motherContent?: LanguageLocaleContent;

    @observable targetContent?: LanguageLocaleContent;

    constructor(translation?: LanguageLocale) {
        super(translation);
        if (translation) {
            this.id = translation.id;
            this.motherContent = createInstance(LanguageLocaleContent, translation.motherContent);
            this.targetContent = createInstance(LanguageLocaleContent, translation.targetContent);
            if (this.targetContent) {
                this.initialContent = this.targetContent.contentEdited;
            }
        }
    }
}